<template>
  <!-- 协会概况-->
  <div id="Assocwindow" class="Assocwindow">
    <Header></Header>
    <Navigate></Navigate>
    
    <div class="content">
      <router-view></router-view>
      <!-- <div class="content1"> -->
          <!-- <div class="title">
            协会概况
          </div> -->
          <!-- <div  @mouseleave="mouseleave" class="navigation_content">
                <li><router-link :to="{name:'Assocpro'}">协会简介</router-link></li>
                <li><router-link :to="{name:'ContactInfo'}">协会领导</router-link></li>
                <li><router-link :to="{name:'Assocarticle'}">协会章程</router-link></li>
                <li><router-link :to="{name:'Instframe'}">组织机构</router-link></li>
                <li><router-link :to="{name:'Mandirect'}">常务理事</router-link></li>
                <li><router-link :to="{name:'Directunit'}">理事单位</router-link></li>
                <li><router-link :to="{name:'Admiscrit'}">规章制度</router-link></li>
                <li><router-link :to="{name:'Aplymember'}">申请入会</router-link></li>
          </div> -->
        <!-- </div> -->
    </div>
    <Foot></Foot>
  </div>
  
</template>

<script>
import Header from "@/components/public/heade/index";
import Navigate from "@/components/public/navigation/index";
import Foot from "@/components/public/foot/index";
import BannerLeft from "@/components/public/bannerLeft/index";
export default {
  name: "Assocwindow",
  data() {
    return {
      isShow:false,
    };
  },
  methods: {
        // 中心概况
    mouseenter(){this.isShow = true;},
    // 中心概况
    mouseleave(){this.isShow = false;},
  },
  components: {
    Header,
    Navigate,
    Foot,
    BannerLeft,
  },
};
</script>

<style lang="less" scoped>
#Assocwindow {
  width: 100%;
  height: auto;
  margin: 0 auto;
  position: relative;
  margin-bottom: 25px;
  .title {
  height: 60px;
  line-height: 60px;
  width: 100%;
  padding-left: 5px;
  font-size: 20px;
  font-weight: bold;
  color: #c01b22;
  border-bottom: 1px solid #e3e3e3;
}
.content1{
      background:#F8F8F8;
      padding-left: 35px;
      padding-right: 20px;
      padding-top: 5px;
      padding-bottom: 20px;
}
  li:hover{
    	a{
						color:#C01B22;
					}
  }
  li {
    // list-style: none;
    width: 100%;
    height: 38px;
    font-size: 16px;
    color: #000000;
    // float: left;
    margin-right: 44px;
    cursor: pointer;
    padding: 15px 9px;
    background: #f8f8f8;
    .periodiCon_cluster_Cont_img {
      width: 175px;
      height: 120px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
      
    }
    a {
          color: #333333;
          font-size: 16px;
        }
    .periodiCon_cluster_Cont_right {
      width: 678px;
      float: right;
      p:nth-child(1) {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        a {
          color: #333333;
          font-size: 18px;
        }
      }
      p:nth-child(2) {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        color: #8b8b8b;
        font-size: 14px;
        margin-top: 7px;
        text-align: justify;
        text-indent: 2em;
      }
      p:nth-child(3) {
        width: 100%;
        height: 15px;
        margin-top: 9px;
        span:nth-child(1) {
          color: #909090;
          font-size: 14px;
          float: left;
        }
        span:nth-child(2) a {
          color: #909090;
          font-size: 16px;
          float: right;
        }
      }
    }
  }
  .content {
    width: 1131px;
    height: 100%;
    margin: 0 auto;s
    .crumbs {
      width: 1200px;
      height: 20px;
      position: relative;
      text-align: left;
      margin-top: 24px;
      margin-left: 2%;
      line-height: 20px;
      span:nth-child(2) a {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
      i {
        color: #767c82;
        font-size: 18px;
        margin-left: 10px;
        font-weight: bold;
      }
      i:nth-child(1) {
        color: #000;
        margin-right: 5px;
      }
      span:nth-child(4) a {
        color: #c01b22;
        font-size: 16px;
        margin-left: 10px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .content_body {
      width: 1130px;
      height: 100%;
      margin-left: 3%;
      margin-top: 20px;
      border: 1px solid rgb(159, 146, 146);
      // border: 1px solid #bbbbbb;
      .content_body_left {
        width: 266px;
        height: 100%;
        border-right: 1px solid #eeeeee;
        float: left;
        .content_body_left_divA {
          width: 266px;
          height: 100%;
          background: #f8f8f8;
          position: relative;
          .content_body_left_divA_head {
            width: 100%;
            height: 48px;
            border-bottom: 6px solid #c01b22;
            top: 0;
            margin: 0 auto;
            padding: 0 5px;
            line-height: 42px;
            i {
              font-size: 22px;
              color: #000000;
            }
            i:nth-child(1) {
              margin-right: 15px;
              margin-left: 13px;
            }
            i:nth-child(3) {
              float: right;
              position: relative;
              top: 3px;
            }
            span {
              color: #000000;
              font-size: 20px;
              font-weight: bold;
            }
          }
          .content_body_left_divA_cont {
            width: 100%;
            margin: 0 auto;
            margin-top: 27px;
            li {
              width: 100%;
              float: left;
              list-style: none;
              text-align: center;
              // padding: 15px;
              height: 60px;
              line-height: 60px;
              .content_body_left_list {
                display: inline-block;
                width: 6px;
                height: 6px;
                background: #c01b22;
                margin-right: 6px;
                position: relative;
                top: -3px;
              }
              a {
                color: #000;
                font-size: 16px;
                font-family: Source Han Sans SC;
              }
              .router-link-active {
                display: block;
                width: 100%;
                height: 100%;
                color: #f5f5f5;
                background-color: #c01b22;
              }
            }
            li:nth-child(2n + 2) {
              margin-right: 0;
            }
            li:hover {
              background-color: #c01b22;
              a {
                color: #f5f5f5;
              }
            }
          }
        }
      }
      .content_body_right {
        width: 1130px;
        height: auto;
        // margin-left: 3%;
        // overflow: hidden;
        // overflow-y: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Assocwindow/index.vue